import { summarizeIssues } from '@shared/parse-json';
import { endpointLabel } from '@shared/frontend-logs';
import { logger } from './logger';

/** Best-effort string for a `fetch` input (string, URL or Request). */
export function describeRequestInput(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.toString();
  return input.url || 'unknown';
}

/**
 * The one way to report "an API response did not match its schema". Logs a
 * short path-only message plus summarized `issues` so the collector (which
 * caps msg length and validates issues) always accepts it.
 */
export function logApiValidationFailure(endpoint: string, issues: Parameters<typeof summarizeIssues>[0]): void {
  const label = endpointLabel(endpoint);
  logger.warn(
    { endpoint: label, issueCount: issues.length, issues: summarizeIssues(issues) },
    `[api-validation] ${label}`,
  );
}
